module.exports = __webpack_public_path__ + "img/product_1_1.cd5e8105.jpg";